import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { PaneComponent } from '@rocksoft/cdk';

export interface MdmOptions {
  activationLockAllowedWhileSupervised?: boolean;
}

@Component({
  selector: 'ml-mdm-options-ui',
  templateUrl: './mdm-options.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaneComponent, ReactiveFormsModule, AsyncPipe],
})
export class ManagedSettingsMdmOptionsComponent {
  private readonly fb = inject(UntypedFormBuilder);

  readonly mdmOptions = output<MdmOptions>();

  public readonly mdmOptionsForm = this.fb.group({
    activationLockAllowedWhileSupervised: [false],
  });

  get activationLockAllowedWhileSupervised() {
    return this.mdmOptionsForm.get('activationLockAllowedWhileSupervised') as UntypedFormControl;
  }

  onSubmit() {
    this.mdmOptions.emit(this.mdmOptionsForm.value);
  }
}
